import { useEffect,useState } from "react";
import {  buscarCategoriasLoja,  ICategoriaLoja,} from "shared/services/api/lojas.api";

export function useCategoriasLoja(){

  const [categorias,setCategorias]= useState<ICategoriaLoja[]>([]);

  const [loading,setLoading]=  useState(true);

  useEffect(() => {

    async function load(){

      try{

        const data=  await buscarCategoriasLoja();

        setCategorias(data);

      }catch(error){ console.error(error);
        
        setCategorias([]);

      }finally{

        setLoading(false);
      }
    }

    load();

  }, []);

  return { categorias, loading,
  };
}